import React, { Component } from 'react'

class CampaignSignupModal extends Component {
  render() {
    return <div>TODO</div>
  }
}

export default CampaignSignupModal
